<template>
    <div>
        <div class="do-top box-sizing">
            <div class="do-item">
                <span class="lab">时间：</span>
                <span class="opt">
                    <el-date-picker
                            v-model="timeGroup"
                            type="daterange"
                            unlink-panels
                            value-format="timestamp"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :editable="false"
                            :picker-options="pickerOptions"
                            :default-time="['00:00:00', '23:59:59']"
                            @change="getOrderList">
                    </el-date-picker>
                </span>
<!--                <span class="lab">关键词：</span>-->
<!--                <span class="opt"><el-input class="inp" placeholder="请输入原链接域名或备注" v-model="keyword" clearable></el-input></span>-->
<!--                <span class="btn"><el-button type="primary" @click="getOrderList">搜索</el-button></span>-->
            </div>
        </div>
        <div class="do-mid box-sizing">
            <el-table v-loading="isLoading" :data="tableData" empty-text="暂无数据">
                <el-table-column prop="order_sn" label="订单号" width="200"></el-table-column>

              <el-table-column   label="域名" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.diy_domain!=''"><font style="font-size: 10px;color:blue;background:#409EFF;color:#fff;padding:2px;">自定义</font><br>{{scope.row.diy_domain}}</span>
                  <span v-if="scope.row.diy_domain==''">{{scope.row.domain}}</span>
                </template>
              </el-table-column>
                <el-table-column prop="total_price" label="金额" width="100"></el-table-column>
                <el-table-column label="订单类型" width="80" class-name="text-align">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type==1">新购</span>
                        <span v-if="scope.row.type==2">续费</span>
                    </template>
                </el-table-column>
                <el-table-column prop="add_time" label="创建时间" width="150" class-name="text-align"></el-table-column>
                <el-table-column prop="pay_time" label="支付时间" width="150" class-name="text-align"></el-table-column>
                <el-table-column label="状态" class-name="text-align">
                    <template slot-scope="scope">
                        <font v-if="scope.row.status==0">已取消</font>
                        <font v-else-if="scope.row.status==1" color="red">未支付</font>
                        <font v-else-if="scope.row.status==2" color="green">已完成</font>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-popconfirm title="删除后不可恢复，确认删除？" v-if="scope.row.status!=1" @confirm="delOrder(scope.row.id)">
                            <el-link slot="reference" type="primary" class="action-link">删除</el-link>
                        </el-popconfirm>
                        <el-popconfirm title="确认取消订单吗？" v-if="scope.row.status==1" @confirm="celOrder(scope.row.id)">
                            <el-link slot="reference" type="primary" class="action-link">取消</el-link>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagebar" v-show="total>0">
                <el-pagination background layout="total, prev, pager, next, jumper" :total="total" @current-change="handleCurrentPage"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2';
    export default {
        name: "DomainOrder",
        data() {
            return {
                keyword: "",
                timeGroup: [],
                currentPage: 1,
                total: 0,
                tableData: [],
                isLoading: false,
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                }
            }
        },
        mounted() {
            setTimeout(this.getOrderList,200);
        },
        methods: {
            async getOrderList() {
                this.isLoading = true;
                let start = 0;
                let end = 0;
                if (this.timeGroup === null) this.timeGroup = [];
                if (this.timeGroup.length === 2){
                    start = this.timeGroup[0];
                    end = this.timeGroup[1];
                }
                const getData = {
                    start: Number(start/1000),
                    end: Number(end/1000),
                    p: this.currentPage,
                };
                const {ret,data} = await this.$api.exclusive.getOrderList(getData);
                this.isLoading = false;
                if (ret === 1000){
                    this.total = Number(data.total);
                    this.tableData = data.list;
                }
            },
            async delOrder(id) {
                const {ret} = await this.$api.exclusive.delOrder({id:id});
                if (ret === 1000){
                    this.getOrderList();
                    this.$message.success('删除成功！');
                }
            },
            async celOrder(id) {
                const {ret} = await this.$api.exclusive.celOrder({id:id});
                if (ret === 1000){
                    this.getOrderList();
                    this.$message.success('取消成功！');
                }
            },
            handleCurrentPage(val) {
                this.currentPage = val;
                this.getOrderList();
            },
        }
    }
</script>

<style scoped>
    .do-top{
        width: 100%;
        height: auto;
        padding: 20px;
    }
    .do-top .do-item{
        width: 100%;
        height: 40px;
        color: #666666;
        margin-bottom: 10px;
    }
    .do-top .do-item .lab{
        display: inline-block;
        width: 70px;
        height: 40px;
        font-size: 14px;
        line-height: 40px;
        text-align: right;
        margin-right: 10px;
        vertical-align: top;
    }
    .do-top .do-item .opt{
        display: inline-block;
        width: 350px;
        height: 40px;
        vertical-align: top;
    }
    .do-top .do-item .btn{
        display: inline-block;
        width: 70px;
        height: 40px;
        margin-left: 10px;
        vertical-align: top;
    }
    .do-top .do-item .inp{
        width: 350px;
    }
    .do-mid{
        width: 100%;
        padding: 0 20px;
    }
    .do-mid .pagebar{
        width: 100%;
        height: 52px;
        margin-top: 20px;
    }
    .action-link{
        margin-right: 10px;
    }
</style>
